<template>
  <v-app>
    <component :is="layout">
      <router-view></router-view>
    </component>
  </v-app>
</template>

<script>
const defaultLayout = 'login_layout';
export default {
  name: 'App',
  data: () => ({
    //defaultLayout  : 'login_layout'
  }),

  created: function () {
    // `this` points to the vm instance
    //  console.debug(`**** layout a cargar = ${this.$route.meta.layout} ****`)
  },

  //Alberto vega implementacion de reload y time out funciones para detectar uso de mouse y teclado
  mounted() {
    // $('.btn').mousedown(function(event) {
    //   $('#console').append(
    //   	'data-key: ' +
    //   	event.target.getAttribute('data-key') +
    //     '<br>'
    //   )
    // })
    // setTimeout( function() { router.push({ path: '/login'})}, 1800000000);
    //1800000000
  },

  computed: {
    layout() {
      // return (this.$route.meta.layout || defaultLayout)
      return this.$route.meta.layout || defaultLayout;
    }
  },

  methods: {
    eventoClick: function (dato) {
      console.log(dato);
    },

    eventoTeclado: function (event) {
      console.log(event.key);
    }
  }
};
</script>
<style>
html {
  overflow-y: auto !important;
}
.cke_notifications_area > .cke_notification.cke_notification_warning {
  display: none !important;
}
</style>
